import { useQuery } from "react-query";
import { useConfig } from "../components/ConfigContext";
import { load } from "../lib";


const loadParticipant = (apiUrl, participantId) => {
  return load(`${apiUrl}/participants/${participantId}`);
}

/**
 * Fetch a participant by ID
 * @param {string} participantId - The ID of the participant to fetch
 * @param {object} options - Options to pass to useQuery  (https://react-query.tanstack.com/docs/api#usequery)
 * @returns {object} - The participant object
 */
export const useParticipant = (participantId, options) => {
  const { apiUrl } = useConfig();

  const { data: participant } = useQuery(
    ['participant', participantId],
    () => loadParticipant(apiUrl, participantId),
    { enabled: !!participantId, ...options }
  )

  return { participant };
}
